import { actions as formActions } from 'react-redux-form'

import * as h2Api from '../h2Api'

export const ACCOUNT_REQUEST = 'EDUCATOR_ACCOUNT_REQUEST'
export const RESEND_VERIFICATION_REQUEST = 'EDUCATOR_RESEND_VERIFICATION_REQUEST'
export const GRANT_ACCOUNT_REQUEST = 'EDUCATOR_GRANT_ACCOUNT_REQUEST'

export const requestEducatorAccount = (form, referringEducator) => dispatch => {
  const toPost = referringEducator ? { ...form, referrerCode: referringEducator } : form

  return dispatch(
    h2Api.post('/user/request/educatoraccount', toPost)({ type: ACCOUNT_REQUEST })
  )
}

export const setEducatorForm = () => (dispatch, getState) => {
  const up = getState().authenticationState.userProfile

  if (up) {
    dispatch(
      formActions.change(
        'educatorAccountRequest.educatorAccountRequestForm.firstName',
        `${up.firstName || ''}`
      )
    )
    dispatch(
      formActions.change(
        'educatorAccountRequest.educatorAccountRequestForm.lastName',
        `${up.lastName || ''}`
      )
    )
    dispatch(
      formActions.change(
        'educatorAccountRequest.educatorAccountRequestForm.email',
        `${up.email || ''}`
      )
    )
    dispatch(
      formActions.change(
        'educatorAccountRequest.educatorAccountRequestForm.specifiedUsersRequired',
        up.limit || 25
      )
    )
    dispatch(
      formActions.change(
        'educatorAccountRequest.educatorAccountRequestForm.school',
        up.school
      )
    )
  }

  return Promise.resolve(true)
}

export const requestEducatorGrant = tokenId => dispatch => {
  return dispatch(
    h2Api.get(`/user/request/grant/${tokenId}`)({ type: GRANT_ACCOUNT_REQUEST })
  )
}

export const resendConfirmationEmail = () => dispatch => {
  return dispatch(
    h2Api.post(`/user/request/educatoraccount/resendemail`)({
      type: RESEND_VERIFICATION_REQUEST
    })
  )
}
